import withConfigTransport from '../../services/config-transport/withConfigTransport'
import _VaParallax from './VaParallax.vue'

export const VaParallax = withConfigTransport(_VaParallax)
